export default "__VITE_ASSET__ffcb1f8e__"